import Certificate from './certificate';

const templates = [
  {
    id: 'CAREHAB_2020_TEMPLATE',
    label: 'Document',
    template: Certificate,
  },
];

export default templates;
